// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Col, Row, Image, ListGroup, ListGroupItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Location from '../../images/location.png';
import Campaign from '../../images/campaign.png';
import Booking from '../../images/campaign.png';
import User from '../../images/user.png';
import LocationDetails from '../../images/flag.png';
import OrganisationSelect from '../OrganisationSelect';
import { Building } from '../../components/Icons';
import InfoIcon from '../../components/InfoIcon';
import { getSetting } from '../../actions/settings/settingsCreators';
import type { Dispatch } from 'redux';

type Props = {
  permissions: any,
  organisations: Object[],
  currentOrganisation: Object,
  organisations: Object[],
  image?: string,
  settings: Object,
  updateCurrentOrganisation: (oid: number, s: boolean) => void,
  getOrganisations: (oid?: number, p?: boolean, a?: boolean) => void,
  getSetting: (s: string) => void,
  closeMenu?: Function,
  router: any
};

class CustomerMenu extends React.Component<Props> {
  hasPermission = (name: string) =>
    this.props.permissions.find(p => p.permissionName === name);

  componentDidMount() {
    const { getSetting } = this.props;
    getSetting('customerHeadingInfoHoverText');
    getSetting('customerCampaignInfoHoverText');
    getSetting('customerBookingsInfoHoverText');
    getSetting('customerCatchmentSetsInfoHoverText');
    getSetting('customerSubAccountsInfoHoverText');
    getSetting('customerDetailsInfoHoverText');
    getSetting('customerUserInfoHoverText');
  }

  render() {
    const {
      closeMenu,
      currentOrganisation,
      organisations,
      settings
    } = this.props;
    const disabled = !currentOrganisation.id;
    return (
      <div className="customer-menu">
        <h2>
          Customer
          {settings && settings.customerHeadingInfoHoverText && (
            <InfoIcon placement="bottom">
              <div
                dangerouslySetInnerHTML={{
                  __html: settings.customerHeadingInfoHoverText.value
                }}
              />
            </InfoIcon>
          )}
        </h2>
        <div className="module">
          {this.props.image && (
            <Image src={this.props.image} alt="" responsive />
          )}
          <Row>
            <Col xs={12} className="main-menu-org-dropdown">
              <OrganisationSelect
                organisations={organisations}
                {...this.props}
                onClickNew={closeMenu}
              />
            </Col>
          </Row>

          <ListGroup>
            <ul>
              {this.hasPermission('User') && (
                <li className="campaigns">
                  <LinkContainer
                    to={`/customer/${currentOrganisation.id}/campaigns`}
                    onClick={closeMenu}
                    disabled={disabled}
                  >
                    <ListGroupItem className="no-underline">
                      <Image src={Campaign} className="dashboard-icon" alt="" />{' '}
                      Campaigns
                      {settings && settings.customerCampaignInfoHoverText && (
                        <InfoIcon>
                          {settings.customerCampaignInfoHoverText.value}
                        </InfoIcon>
                      )}
                    </ListGroupItem>
                  </LinkContainer>
                </li>
              )}
              {this.hasPermission('User') && (
                <li className="bookings">
                  <LinkContainer
                    to={`/customer/${currentOrganisation.id}/bookings`}
                    onClick={closeMenu}
                    disabled={disabled}
                  >
                    <ListGroupItem className="no-underline">
                      <Image src={Booking} className="dashboard-icon" alt="" />{' '}
                      Bookings
                      {settings && settings.customerBookingsInfoHoverText && (
                        <InfoIcon>
                          {settings.customerBookingsInfoHoverText.value}
                        </InfoIcon>
                      )}
                    </ListGroupItem>
                  </LinkContainer>
                </li>
              )}

              {this.hasPermission('Admin') && (
                <li className="shape-sets">
                  <LinkContainer
                    to={`/customer/${currentOrganisation.id}/catchment-sets`}
                    onClick={closeMenu}
                    disabled={disabled}
                  >
                    <ListGroupItem className="no-underline">
                      <Image src={Location} className="dashboard-icon" alt="" />{' '}
                      Catchment Sets
                      {settings &&
                        settings.customerCatchmentSetsInfoHoverText && (
                          <InfoIcon>
                            {settings.customerCatchmentSetsInfoHoverText.value}
                          </InfoIcon>
                        )}
                    </ListGroupItem>
                  </LinkContainer>
                </li>
              )}

              {this.hasPermission('Admin') && (
                <li className="sub-accounts">
                  <LinkContainer
                    to={`/customer/${currentOrganisation.id}/sub-accounts`}
                    onClick={closeMenu}
                    disabled={disabled}
                  >
                    <ListGroupItem className="no-underline">
                      <Image
                        src={LocationDetails}
                        className="dashboard-icon"
                        alt=""
                      />{' '}
                      Sub-Accounts
                      {settings &&
                        settings.customerSubAccountsInfoHoverText && (
                          <InfoIcon>
                            {settings.customerSubAccountsInfoHoverText.value}
                          </InfoIcon>
                        )}
                    </ListGroupItem>
                  </LinkContainer>
                </li>
              )}

              {this.hasPermission('Admin') && (
                <li className="users">
                  <LinkContainer
                    to={`/customer/${currentOrganisation.id}/users`}
                    onClick={closeMenu}
                    disabled={disabled}
                  >
                    <ListGroupItem className="no-underline">
                      <Image src={User} className="dashboard-icon" alt="" />{' '}
                      Users
                      {settings && settings.customerUserInfoHoverText && (
                        <InfoIcon>
                          {settings.customerUserInfoHoverText.value}
                        </InfoIcon>
                      )}
                    </ListGroupItem>
                  </LinkContainer>
                </li>
              )}

              {this.hasPermission('Admin') && (
                <li className="customer-details">
                  <LinkContainer
                    to={`/customer/${currentOrganisation.id}`}
                    onClick={closeMenu}
                    disabled={disabled}
                  >
                    <ListGroupItem className="no-underline">
                      <Building height="32px" width="32px" /> Customer Details
                      {settings && settings.customerDetailsInfoHoverText && (
                        <InfoIcon>
                          {/* Hover text value is directly injected as HTML as we needed to display an unordered list in the tooltip, retrieved via the API */}
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                settings.customerDetailsInfoHoverText.value
                            }}
                          />
                        </InfoIcon>
                      )}
                    </ListGroupItem>
                  </LinkContainer>
                </li>
              )}
            </ul>
          </ListGroup>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators(
    {
      getSetting
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerMenu);



// WEBPACK FOOTER //
// ./src/components/menuItems/CustomerMenu.js